import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/traversal/has/has.js";
import "dabbyjs/src/traversal/children/children.js";
import "dabbyjs/src/traversal/parents/parents.js";
import "dabbyjs/src/traversal/filter/filter.js";
import "dabbyjs/src/traversal/add/add.js";
import "dabbyjs/src/traversal/eq/eq.js";
import "dabbyjs/src/attributes/css/css.js";
import "dabbyjs/src/events/on/on.js";

export default obj => {
	if (obj.length) {
		$("tr", obj).has("td > h3 > a").each(function () {
			const $this = $(this),
				td = $("td", $this),
				link = td.children("h3").children("a").eq(0); // the main link to click

			td
				.filter((i, item) => !$("input,a,button,label", item).length) // remove cells with other clickable controls
				.add(link.parent().parent()) // add the cell with the main link
				.css("cursor", "pointer") // make the mouse a pointer
				.on("click", e => { // generate click event on main link when any cells are clicked
					if (e.target.tagName.toLowerCase() !== "a") { // generate a click event on elements except anchors
						const evt = new MouseEvent("click", {
							view: window,
							bubbles: true,
							cancelable: true
						});
						link.get(0).dispatchEvent(evt);
					}
				});
		});
	}
};
